export default __webpack_public_path__ + "static/media/8666656_check_circle_icon.41b4a19a.svg";